import { createIcon, Svg } from "@gluestack-ui/icon";
import { Path } from "react-native-svg";

const SunsetIcon = createIcon({
  Root: Svg,
  viewBox: "0 0 28 28",
  path: (
    <>
      <Path
        d="M4.66683 21.0007H2.3335M7.36663 14.3671L5.71672 12.7172M20.6336 14.3671L22.2835 12.7172M25.6668 21.0007H23.3335M8.16683 21.0007C8.16683 17.779 10.7785 15.1673 14.0002 15.1673C17.2218 15.1673 19.8335 17.779 19.8335 21.0007M25.6668 25.6673H2.3335M18.6668 5.83398L14.0002 10.5007M14.0002 10.5007L9.3335 5.83398M14.0002 10.5007V2.33398"
        stroke="#AEBFFC"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
});

export { SunsetIcon };
